import { render, staticRenderFns } from "./QuinielaPartidos.vue?vue&type=template&id=547d88fe&lang=pug"
import script from "./QuinielaPartidos.vue?vue&type=script&lang=js"
export * from "./QuinielaPartidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports